import { IServerProps } from 'common/types/common';
import { Layout } from 'layout';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const LegalContent = dynamic(() =>
  import('modules/legal/LegalContent').then(mod => mod.LegalContent),
);

const PrivacyPolicyPage = () => {
  const { t } = useTranslation('meta');

  const seo = {
    alternate: t('privacyPolicy.alternate', { returnObjects: true }),
    description: t('privacyPolicy.description'),
    image: t('privacyPolicy.image'),
    slug: t('privacyPolicy.slug'),
    title: t('privacyPolicy.title'),
  };
  return (
    <Layout dark seo={seo}>
      <LegalContent
        title={t('pagePrivacyPolicy:title')}
        content={t('pagePrivacyPolicy:content', { returnObjects: true })}
      />
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
): Promise<IServerProps<IPrivacyPolicyPageProps>> => {
  const locale = await serverSideTranslations(context.locale || 'en', [
    'common',
    'meta',
    'pagePrivacyPolicy',
  ]);

  return {
    props: {
      data: { referer: context.req.headers.referer || null },
      ...locale,
    },
  };
};

interface IPrivacyPolicyPageProps {
  data: { referer?: string | null } | Record<string, never>;
}

export default PrivacyPolicyPage;
